import getAPIProduct from '@api/product';
import type { TcoCalculateRequest } from '@model/dto/papi-tco-calculate';
import type { AugmentedStore } from '@model/vue-store/augmented-store';
import { Logger } from '@utils/logger';
import type { RawAxiosRequestConfig, AxiosResponse } from 'axios';

export default {
    namespaced: true,

    actions: {
        // Client-only POST to the TCO calculator endpoint. The product-api client is created with
        // `validateStatus: () => true`, so we forward the raw response (200 / 422 / other) to the
        // component and let it branch — 422 carries `{ errors }` we surface against the fields.
        async calculate(this: AugmentedStore, _store: never, data: TcoCalculateRequest): Promise<AxiosResponse | { status: number }> {
            const client = getAPIProduct(this.$context);

            const cfg: RawAxiosRequestConfig = {
                method: 'POST',
                url: '/api/calculator/tco/calculate',
                timeout: 30000,
                validateStatus: () => true,
                data,
            };

            try {
                return await client.request(cfg);
            } catch (error) {
                Logger.error({ error });
                return { status: 0 };
            }
        },
    },
};
